"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var Wrapper = _styledComponents["default"].span.withConfig({
  displayName: "Wrapperstyles__Wrapper",
  componentId: "sc-1puig9b-0"
})(["border-right:1px solid ", ";margin-right:", ";padding-right:", ";position:relative;"], _tokens["default"].border.color, _tokens["default"].spaceSm, _tokens["default"].spaceSm);

var _default = Wrapper;
exports["default"] = _default;
//# sourceMappingURL=Wrapper.styles.js.map